import { useState } from "react"
import TextImageBlock from "@/common/partials/textImageBlock/textImageBlock"
import TextVideoBlock from "@/common/partials/textVideoBlock/textVideoBlock"
import ArticleContent from "@/common/article/content"

export default function FeaturedArticle({ block }) {
  const [hovered, setHovered] = useState(false)

  const { attrs } = block
  const { article } = attrs

  if (article.length === 0) {
    return null
  }
  /* If featured article uses video */
  if (article.video) {
    return (
      <TextVideoBlock
        layout={attrs.layout}
        hovered={hovered}
        setHovered={setHovered}
        data={{
          url: article.video,
          poster: {
            url: article.image.url,
            alt: article.image.alt
          }
        }}
        hasPlate={attrs?.theme !== "transparent"}
        plateColor={attrs?.theme}>
        <ArticleContent
          article={article}
          hovered={hovered}
          setHovered={setHovered}
        />
      </TextVideoBlock>
    )
  } else {
    return (
      <TextImageBlock
        layout={block.attrs.layout}
        image={block.attrs.article.image}
        hasPlate={attrs?.theme !== "transparent"}
        plateColor={attrs?.theme}
        padding={attrs?.theme === "on-plate"}>
        <ArticleContent article={article} />
      </TextImageBlock>
    )
  }
}
